var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClawsonConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.048,
    height: 51.828,
    viewBox: "0 0 85.048 51.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35322",
    "data-name": "Path 35322",
    d: "M11.037,0a20.989,20.989,0,1,1,0,41.978c-11.592,0-22.715-10.06-22.715-21.652S-.555,0,11.037,0Z",
    transform: "translate(11.679 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15460",
    "data-name": "Rectangle 15460",
    width: 40.342,
    height: 50.875,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35222",
    "data-name": "Path 35222",
    d: "M212.119,518.05l-1.04,3.9,5.43-.071-1.16-3.9Z",
    transform: "translate(-211.079 -517.974)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35227",
    "data-name": "Path 35227",
    d: "M182.484,102.07c-.9,1.919-3.781,11.413-3.833,11.879-.063.607-.694,2.292.721,9.478,1.489,7.551,3.081,15.977,3.081,15.977l3.187.054s1.617-8.48,3.1-16.033c1.417-7.186.787-8.871.721-9.478-.049-.465-2.934-9.959-3.827-11.878-.13-.279-.871-.426-1.6-.426-.711,0-1.416.138-1.55.426",
    transform: "translate(-178.457 -101.644)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35231",
    "data-name": "Path 35231",
    d: "M189.859,348.718l2.784,14.478,3.538-.014,2.863-14.679Z",
    transform: "translate(-189.859 -348.503)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35235",
    "data-name": "Path 35235",
    d: "M205.7,119.807a1.315,1.315,0,1,0,1.315-1.315,1.315,1.315,0,0,0-1.315,1.315",
    transform: "translate(-205.699 -118.492)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35238",
    "data-name": "Path 35238",
    d: "M248.474,119.807a1.315,1.315,0,1,0,1.315-1.315,1.315,1.315,0,0,0-1.315,1.315",
    transform: "translate(-248.474 -118.492)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35245",
    "data-name": "Path 35245",
    d: "M301.583,67.668l-.338.027-.386-3.043c-6.838,3.914-3.762,9.9-3.762,9.9l-5.5,3.819s6.9,4.507,12.619-3a2.764,2.764,0,0,0,.288-.49,9.435,9.435,0,0,0-3.514-12.338Z",
    transform: "translate(-291.596 -62.545)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35248",
    "data-name": "Path 35248",
    d: "M2.909,107.642a2.348,2.348,0,0,0,.434.369c7.851,5.237,12.91-1.275,12.91-1.275L9.808,104.92s.959-6.661-6.783-8.135l.624,3-.327.081L2.21,94.833a9.438,9.438,0,0,0,.7,12.809",
    transform: "translate(0 -94.833)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35252",
    "data-name": "Path 35252",
    d: "M280.639,212.377l-.014,1.056,3.272.257.318-1.919.185-1.113.18-.151-.082-.414Z",
    transform: "translate(-280.625 -210.093)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35255",
    "data-name": "Path 35255",
    d: "M145.566,221.462l-.365,1.066-.2.123.012.424,4.182-1.619.188-1.038-3.187-.795Z",
    transform: "translate(-144.998 -219.624)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27482",
    "data-name": "Group 27482",
    transform: "translate(-382.833 -66.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27444",
    "data-name": "Group 27444",
    transform: "translate(336.558 67.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24867",
    "data-name": "Group 24867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46962",
    "data-name": "Path 46962",
    d: "M441.823,284.336l-.88-1.213-1.5.037a.206.206,0,0,1-.172-.327l.882-1.212-.5-1.414a.206.206,0,0,1,.258-.264l1.425.464,1.191-.911a.206.206,0,0,1,.331.164v1.5l1.234.851a.206.206,0,0,1-.053.366l-1.426.462-.428,1.437a.206.206,0,0,1-.364.062",
    transform: "translate(-379.695 -260.66)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46989",
    "data-name": "Path 46989",
    d: "M441.823,284.336l-.88-1.213-1.5.037a.206.206,0,0,1-.172-.327l.882-1.212-.5-1.414a.206.206,0,0,1,.258-.264l1.425.464,1.191-.911a.206.206,0,0,1,.331.164v1.5l1.234.851a.206.206,0,0,1-.053.366l-1.426.462-.428,1.437a.206.206,0,0,1-.364.062",
    transform: "translate(-376.405 -237.449)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46963",
    "data-name": "Path 46963",
    d: "M1852.019,55.6l-1.189-.272.226-1.962-1.69-.612-.071-1.5-.757.036.1,2,1.6.579L1850,55.917l1.79.409Z",
    transform: "translate(-1739.227 -47.813)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46964",
    "data-name": "Path 46964",
    d: "M383.732,107.825l-.9-1.3-1.584,0a.218.218,0,0,1-.174-.35l.961-1.26-.493-1.506a.218.218,0,0,1,.279-.273l1.5.525,1.28-.934a.218.218,0,0,1,.346.181l-.037,1.584,1.284.928a.218.218,0,0,1-.065.385l-1.518.454-.486,1.508a.218.218,0,0,1-.386.057",
    transform: "translate(-325.404 -95.78)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46991",
    "data-name": "Path 46991",
    d: "M382.424,105.339l-.465-.673-.818,0a.112.112,0,0,1-.09-.181l.5-.65-.255-.778a.112.112,0,0,1,.144-.141l.772.271.661-.482a.112.112,0,0,1,.179.093l-.019.818.663.479a.112.112,0,0,1-.034.2l-.784.235-.251.779a.112.112,0,0,1-.2.029",
    transform: "translate(-310.322 -71.018)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46966",
    "data-name": "Path 46966",
    d: "M1087.307,3.393l-1.7.563-1.208-2.642-2.593.516L1080.574,0l-.926.621,1.642,2.446,2.458-.489L1085,5.327l2.564-.847Z",
    transform: "matrix(0.788, -0.616, 0.616, 0.788, -778.97, 667.701)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46993",
    "data-name": "Path 46993",
    d: "M2319.31,319.728l-1.556.21-.709,1.4a.216.216,0,0,1-.387,0l-.681-1.415-1.551-.241a.216.216,0,0,1-.116-.369l1.135-1.085-.25-1.55a.216.216,0,0,1,.315-.224l1.383.744,1.4-.717a.216.216,0,0,1,.311.231l-.28,1.545,1.113,1.107a.216.216,0,0,1-.123.367",
    transform: "translate(-2198.641 -274.422)",
    fill: "#3e5d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46968",
    "data-name": "Path 46968",
    d: "M557.094,108.565l-1.875.075-.737,1.765-2.107-.065-.206,2.122-2.386.032-.431,1.931-2.291.406-.154-.867,1.713-.3.454-2.037,2.294-.031.209-2.158,2.325.071.72-1.724,1.737-.069.236-1.231.865.166Z",
    transform: "translate(-480.13 -99.321)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46969",
    "data-name": "Path 46969",
    d: "M847.656,40.561a1.535,1.535,0,0,1,.971-.889,1.188,1.188,0,0,1,1.512.794c.233.723-.126,1.781-1.532,3.053-1.884-.214-2.792-.865-3.025-1.588a1.189,1.189,0,0,1,.766-1.527,1.535,1.535,0,0,1,1.307.156",
    transform: "translate(-758.661 -36.948)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46970",
    "data-name": "Path 46970",
    d: "M791.926,71.817a15.817,15.817,0,0,0,1.772-.366c.176-.047.5-.076.577-.26a.192.192,0,0,0-.065-.254c-.169-.112-.418.017-.6.064-.541.144-1.16.281-1.793.383a.225.225,0,0,0-.164.269.227.227,0,0,0,.269.164",
    transform: "translate(-708.415 -66.125)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46971",
    "data-name": "Path 46971",
    d: "M931.756,58.366c.26-.064.518-.134.777-.2a2.45,2.45,0,0,0,.764-.246.193.193,0,0,0-.088-.359,2.424,2.424,0,0,0-.783.164c-.259.069-.517.138-.775.211a.223.223,0,0,0,.105.433",
    transform: "translate(-838.848 -53.685)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46972",
    "data-name": "Path 46972",
    d: "M838.5,104.9a2.785,2.785,0,0,1,.78-1.192.18.18,0,0,0-.21-.287,2.072,2.072,0,0,0-1,1.358.222.222,0,0,0,.427.12",
    transform: "translate(-751.703 -96.448)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46973",
    "data-name": "Path 46973",
    d: "M886.74,113.675a1.971,1.971,0,0,1-.076-.812c.02-.168.217-.675-.108-.675-.306,0-.337.511-.353.728a2.321,2.321,0,0,0,.1.865c.086.273.519.171.434-.105",
    transform: "translate(-796.602 -104.643)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46974",
    "data-name": "Path 46974",
    d: "M918.265,95.3l.514.2c.171.067.348.182.528.094a.2.2,0,0,0,.077-.261c-.068-.169-.325-.212-.481-.272l-.515-.2a.228.228,0,0,0-.279.157.231.231,0,0,0,.156.279",
    transform: "translate(-826.359 -88.476)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46975",
    "data-name": "Path 46975",
    d: "M826.262,19.134c-.9-1.179-.888-1.188-1.027-1.268a.2.2,0,0,0-.289.214c.042.163.038.135.986,1.372a.231.231,0,0,0,.324.006.235.235,0,0,0,.006-.324",
    transform: "translate(-739.464 -16.641)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46976",
    "data-name": "Path 46976",
    d: "M872.683,8.1a3.391,3.391,0,0,0,.007-.728c-.022-.226-.025-.575-.266-.673a.169.169,0,0,0-.169.042c-.151.173-.036.458-.016.666a4.015,4.015,0,0,1,0,.684.224.224,0,0,0,.218.226.227.227,0,0,0,.226-.218",
    transform: "translate(-783.527 -6.245)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46977",
    "data-name": "Path 46977",
    d: "M914.349,15.125c.012-.111-.094-.185-.189-.2-.2-.024-.386.211-.513.338a3.894,3.894,0,0,0-.4.481.226.226,0,0,0,.078.306.229.229,0,0,0,.306-.078c.483-.627.688-.577.718-.851",
    transform: "translate(-821.802 -13.923)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46979",
    "data-name": "Path 46979",
    d: "M1960.511,152.285a9.026,9.026,0,0,0-4.99.785,16.066,16.066,0,0,0-4.448,3.763l3.36,2.3s-.347-3.952,6.077-6.853",
    transform: "translate(-1844.868 -135.976)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46980",
    "data-name": "Path 46980",
    d: "M2075.845,90.368l.421-2.18-1.557-1.583a.3.3,0,0,1,.179-.517l2.2-.273,1.024-1.97a.305.305,0,0,1,.547.012l.941,2.011,2.19.365a.305.305,0,0,1,.158.524l-1.623,1.516.329,2.2a.305.305,0,0,1-.449.312l-1.943-1.074-1.987.992a.305.305,0,0,1-.436-.331",
    transform: "translate(-1960.107 -72.053)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46981",
    "data-name": "Path 46981",
    d: "M93.693,433.341a9.027,9.027,0,0,1,4.99.785,16.063,16.063,0,0,1,4.447,3.764l-3.359,2.3s.347-3.952-6.078-6.853",
    transform: "translate(-41.116 -408.527)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46982",
    "data-name": "Path 46982",
    d: "M6.206,371.424l-.421-2.18,1.557-1.583a.305.305,0,0,0-.18-.517l-2.2-.273L3.933,364.9a.305.305,0,0,0-.547.011l-.941,2.011-2.19.365a.305.305,0,0,0-.158.524l1.622,1.516-.329,2.2a.305.305,0,0,0,.449.312l1.943-1.074,1.987.992a.305.305,0,0,0,.436-.331",
    transform: "translate(46.276 -344.604)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46983",
    "data-name": "Path 46983",
    d: "M1628.615,36.161a1.089,1.089,0,1,1-1.089-1.088,1.089,1.089,0,0,1,1.089,1.088",
    transform: "translate(-1528.939 -33.874)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46984",
    "data-name": "Path 46984",
    d: "M2228.475,52.169a.909.909,0,1,1-.909-.909.909.909,0,0,1,.909.909",
    transform: "translate(-2101.918 -41.813)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46985",
    "data-name": "Path 46985",
    d: "M1754.33,130.277a.926.926,0,1,1-.926-.926.926.926,0,0,1,.926.926",
    transform: "translate(-1649.628 -120.652)",
    fill: "#f79c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46990",
    "data-name": "Path 46990",
    d: "M1754.33,130.277a.926.926,0,1,1-.926-.926.926.926,0,0,1,.926.926",
    transform: "translate(-1646.921 -97.683)",
    fill: "#f79c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46986",
    "data-name": "Path 46986",
    d: "M145.819,190.883a1.027,1.027,0,1,1-1.027-1.027,1.027,1.027,0,0,1,1.027,1.027",
    transform: "translate(-94.098 -177.089)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46987",
    "data-name": "Path 46987",
    d: "M150.961,583.554a.465.465,0,1,1-.465-.465.465.465,0,0,1,.465.465",
    transform: "translate(-94.408 -544.878)",
    fill: "#9bc1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46988",
    "data-name": "Path 46988",
    d: "M2306.184,604.618a.7.7,0,1,1-.7-.7.7.7,0,0,1,.7.7",
    transform: "translate(-2174.861 -564.78)",
    fill: "#fae0b2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25385",
    "data-name": "Group 25385",
    transform: "translate(-428.93 -204.868)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1027",
    "data-name": "Ellipse 1027",
    cx: 19.852,
    cy: 19.987,
    rx: 19.852,
    ry: 19.987,
    transform: "translate(836.212 282.742)",
    fill: "#e5f3f2",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_410",
    "data-name": "Mask Group 410",
    transform: "translate(833.954 280.738)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14232",
    "data-name": "Group 14232",
    transform: "translate(0.877 4.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14195",
    "data-name": "Group 14195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14194",
    "data-name": "Group 14194",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35201",
    "data-name": "Path 35201",
    d: "M160.826,357.2a.2.2,0,0,0-.2-.19h-3.819a.1.1,0,0,0-.1.1h0a.1.1,0,0,0,.1.1h4.007a.01.01,0,0,0,.008,0c.005,0,.005,0,.005-.008",
    transform: "translate(-142.515 -324.681)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35202",
    "data-name": "Path 35202",
    d: "M114.839,318.919l-3.593-3.593a.012.012,0,0,0-.014,0l-.065.065a.1.1,0,0,0,0,.14h0l3.457,3.457a.1.1,0,0,0,.141,0h0Z",
    transform: "translate(-101.074 -286.771)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35203",
    "data-name": "Path 35203",
    d: "M149.262,352.862a.435.435,0,1,1-.435.435.435.435,0,0,1,.435-.435m0,.158a.278.278,0,1,1-.278.278.281.281,0,0,1,.278-.278",
    transform: "translate(-135.35 -320.91)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35204",
    "data-name": "Path 35204",
    d: "M278.531,357.11a.1.1,0,0,1,.1-.1h4.007a.013.013,0,0,1,.014.012h0a.2.2,0,0,1-.2.191h-3.819A.1.1,0,0,1,278.531,357.11Z",
    transform: "translate(-253.31 -324.682)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35205",
    "data-name": "Path 35205",
    d: "M329.243,319.369a.1.1,0,0,1,0-.14h0l3.457-3.457a.1.1,0,0,1,.14,0h0l.071.071-3.593,3.593a.012.012,0,0,1-.014,0Z",
    transform: "translate(-299.402 -287.15)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35206",
    "data-name": "Path 35206",
    d: "M322.732,352.862a.435.435,0,1,0,.435.435.435.435,0,0,0-.435-.435m0,.158a.278.278,0,1,0,.278.278.278.278,0,0,0-.278-.278",
    transform: "translate(-293.113 -320.91)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35207",
    "data-name": "Path 35207",
    d: "M176.577,390.223a.2.2,0,0,1-.2.2h-3.819a.1.1,0,0,1,0-.2h3.82a.2.2,0,0,1,.2.2h0Z",
    transform: "translate(-156.84 -354.888)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35208",
    "data-name": "Path 35208",
    d: "M141.975,393.431l-2.458,2.458a.01.01,0,0,1-.014,0l0,0-.065-.065a.1.1,0,0,1,0-.142l2.322-2.322a.1.1,0,0,1,.142,0Z",
    transform: "translate(-126.784 -357.714)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35209",
    "data-name": "Path 35209",
    d: "M165.046,387.818a.435.435,0,1,0-.435-.435.435.435,0,0,0,.435.435m0-.158a.278.278,0,1,0-.278-.278.272.272,0,0,0,.267.278Z",
    transform: "translate(-149.705 -351.909)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35210",
    "data-name": "Path 35210",
    d: "M262.781,390.3a.1.1,0,0,0,.1.1h4.01a.013.013,0,0,0,.014-.012.006.006,0,0,0,0,0,.2.2,0,0,0-.2-.191h-3.819a.105.105,0,0,0-.1.1",
    transform: "translate(-238.986 -354.861)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35211",
    "data-name": "Path 35211",
    d: "M313.5,392.949a.1.1,0,0,0,0,.142l2.322,2.322a.1.1,0,0,0,.142,0l.071-.071-2.458-2.458a.01.01,0,0,0-.014,0l0,0Z",
    transform: "translate(-285.09 -357.304)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35212",
    "data-name": "Path 35212",
    d: "M306.983,387.818a.435.435,0,1,1,.435-.435.435.435,0,0,1-.435.435m0-.158a.278.278,0,1,1,.278-.278.278.278,0,0,1-.278.278Z",
    transform: "translate(-278.79 -351.909)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35213",
    "data-name": "Path 35213",
    d: "M196,398.742l-2.907,2.907a.008.008,0,0,1-.01,0l0,0-.065-.065a.1.1,0,0,1,0-.141h0l2.771-2.771a.1.1,0,0,1,.14,0h0Z",
    transform: "translate(-175.513 -362.544)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35214",
    "data-name": "Path 35214",
    d: "M190.18,436.665v2.659h-.1a.1.1,0,0,1-.1-.1v-2.455a.1.1,0,0,1,.1-.1Z",
    transform: "translate(-172.776 -397.124)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35215",
    "data-name": "Path 35215",
    d: "M187.39,429.529a.437.437,0,1,0-.618,0h0a.438.438,0,0,0,.618,0m-.112-.112a.277.277,0,1,0-.393,0,.277.277,0,0,0,.393,0l0,0",
    transform: "translate(-169.743 -389.956)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35216",
    "data-name": "Path 35216",
    d: "M254.969,398.311a.1.1,0,0,0,0,.141h0l2.771,2.771a.1.1,0,0,0,.141,0h0l.071-.071-2.9-2.9a.008.008,0,0,0-.011,0l0,0Z",
    transform: "translate(-231.854 -362.184)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35217",
    "data-name": "Path 35217",
    d: "M288.671,436.638a.1.1,0,0,0-.1.1v2.455a.1.1,0,0,0,.1.1h.1v-2.659Z",
    transform: "translate(-262.44 -397.097)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35218",
    "data-name": "Path 35218",
    d: "M284.578,429.529a.437.437,0,1,1,.618,0h0a.438.438,0,0,1-.618,0m.112-.112a.277.277,0,1,1,.393,0,.277.277,0,0,1-.393,0l0,0",
    transform: "translate(-258.693 -389.956)",
    fill: "#023",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14197",
    "data-name": "Group 14197",
    transform: "translate(19.114 46.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14196",
    "data-name": "Group 14196",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35219",
    "data-name": "Path 35219",
    d: "M216.8,513.326a.455.455,0,1,1-.909,0v0a.469.469,0,0,1-.454.476.443.443,0,0,1-.318-.136.615.615,0,0,1-.675.28.661.661,0,0,1-.458-.794c.207-.882.58-2.466.789-3.345a.625.625,0,0,1,.74-.483l.016,0a.521.521,0,0,1,.435.594.526.526,0,0,1-.022.089l-.011.049h.748l-.011-.049c-.084-.351.163-.6.5-.683a.623.623,0,0,1,.752.46l0,.019c.207.882.58,2.463.789,3.345a.661.661,0,0,1-.457.795.613.613,0,0,1-.678-.286.45.45,0,0,1-.321.142.468.468,0,0,1-.454-.479Z",
    transform: "translate(-213.701 -510.096)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35220",
    "data-name": "Path 35220",
    d: "M242.278,521.359l.547.027.005-.968.272.95.463-.212-.77-2.864-.512.005Z",
    transform: "translate(-239.453 -518.264)",
    fill: "#fac2c6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35221",
    "data-name": "Path 35221",
    d: "M226.914,521.359l-.547.027-.005-.968-.272.95-.463-.212.77-2.864.512.005Z",
    transform: "translate(-224.309 -518.264)",
    fill: "#fac2c6",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14199",
    "data-name": "Group 14199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14198",
    "data-name": "Group 14198",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35223",
    "data-name": "Path 35223",
    d: "M182.481,102.07c.272-.585,2.9-.55,3.154,0,.893,1.919,3.778,11.413,3.827,11.878.065.607.7,2.292-.721,9.478-1.486,7.553-3.1,16.033-3.1,16.033l-3.187-.054s-1.592-8.427-3.081-15.977c-1.415-7.186-.784-8.871-.721-9.478.052-.466,2.937-9.96,3.833-11.879",
    transform: "translate(-162.295 -92.441)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14201",
    "data-name": "Group 14201",
    transform: "translate(16.16 9.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14200",
    "data-name": "Group 14200",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35224",
    "data-name": "Path 35224",
    d: "M181.743,301.821l10.6.063-2.518,19.543-5.427.082Z",
    transform: "translate(-181.446 -283.695)",
    fill: "#f14a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15462",
    "data-name": "Rectangle 15462",
    width: 11.878,
    height: 0.226,
    transform: "translate(-0.671 18.126)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15463",
    "data-name": "Rectangle 15463",
    width: 11.878,
    height: 0.226,
    transform: "translate(-0.671 24.033)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15464",
    "data-name": "Rectangle 15464",
    width: 11.878,
    height: 0.226,
    transform: "translate(-0.671 28.706)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15465",
    "data-name": "Rectangle 15465",
    width: 11.878,
    height: 0.226,
    transform: "translate(-0.671 33.377)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35225",
    "data-name": "Path 35225",
    d: "M206.068,117.38a1.421,1.421,0,1,1-1.421,1.421,1.421,1.421,0,0,1,1.421-1.421",
    transform: "translate(-202.276 -115.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35226",
    "data-name": "Path 35226",
    d: "M248.842,117.38a1.421,1.421,0,1,1-1.421,1.421,1.421,1.421,0,0,1,1.421-1.421",
    transform: "translate(-241.176 -115.955)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14203",
    "data-name": "Group 14203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14202",
    "data-name": "Group 14202",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35228",
    "data-name": "Path 35228",
    d: "M189.859,348.715l2.784,14.478,3.538-.014,2.863-14.679Z",
    transform: "translate(-172.667 -316.943)",
    fill: "#3e5d8b",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14205",
    "data-name": "Group 14205",
    transform: "translate(17.192 31.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14204",
    "data-name": "Group 14204",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35229",
    "data-name": "Path 35229",
    d: "M189.424,349.534l.049,1.581-1.328,1.133.8,7.872-.585-7.675,1.374-1.3-.1-1.641Z",
    transform: "translate(-188.3 -349.411)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35230",
    "data-name": "Path 35230",
    d: "M275.322,349.534l-.049,1.581,1.328,1.133-.8,7.872.585-7.675-1.374-1.3.1-1.641Z",
    transform: "translate(-267.303 -349.411)",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14207",
    "data-name": "Group 14207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14206",
    "data-name": "Group 14206",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35232",
    "data-name": "Path 35232",
    d: "M217.061,496.981l4.344-.139.046,1.3-4.341.142Z",
    transform: "translate(-197.405 -451.853)",
    fill: "#587cb2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35233",
    "data-name": "Path 35233",
    d: "M207.013,118.492a1.315,1.315,0,1,1-1.315,1.315,1.315,1.315,0,0,1,1.315-1.315",
    transform: "translate(-187.072 -107.762)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14209",
    "data-name": "Group 14209",
    transform: "translate(18.626 10.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14208",
    "data-name": "Group 14208",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35234",
    "data-name": "Path 35234",
    d: "M207.134,111.489a1.29,1.29,0,1,1-1.315,1.29,1.3,1.3,0,0,1,1.315-1.29",
    transform: "translate(-205.808 -112.123)",
    fill: "#023"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14211",
    "data-name": "Group 14211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14210",
    "data-name": "Group 14210",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35236",
    "data-name": "Path 35236",
    d: "M249.788,118.492a1.315,1.315,0,1,1-1.315,1.315,1.315,1.315,0,0,1,1.315-1.315",
    transform: "translate(-225.973 -107.762)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14213",
    "data-name": "Group 14213",
    transform: "translate(22.5 10.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14212",
    "data-name": "Group 14212",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35237",
    "data-name": "Path 35237",
    d: "M249.908,111.489a1.29,1.29,0,1,1-1.315,1.29,1.3,1.3,0,0,1,1.315-1.29",
    transform: "translate(-248.582 -112.123)",
    fill: "#023"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14215",
    "data-name": "Group 14215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14214",
    "data-name": "Group 14214",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35239",
    "data-name": "Path 35239",
    d: "M247.836,9.981l-.093-.014a.1.1,0,0,0-.109.079l-1.277,8.347a.1.1,0,0,0,.079.109l.082.014c.005,0,.011,0,.011-.008Z",
    transform: "translate(-224.049 -9.064)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35240",
    "data-name": "Path 35240",
    d: "M255.427,0a.642.642,0,1,1-.642.642A.642.642,0,0,1,255.427,0",
    transform: "translate(-231.714)",
    fill: "#f14a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35241",
    "data-name": "Path 35241",
    d: "M218.221,10.191a.1.1,0,0,1,.079-.109l.082-.014c.006,0,.011,0,.011.008l1.352,8.511-.093.014a.1.1,0,0,1-.109-.079Z",
    transform: "translate(-198.46 -9.156)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35242",
    "data-name": "Path 35242",
    d: "M212.412.24a.642.642,0,1,1-.642.642.642.642,0,0,1,.642-.642",
    transform: "translate(-192.594 -0.218)",
    fill: "#f14a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35243",
    "data-name": "Path 35243",
    d: "M291.6,78.373l5.5-3.819s-3.076-5.988,3.762-9.9l.386,3.043.337-.027-.593-5.123a9.435,9.435,0,0,1,3.514,12.338,2.763,2.763,0,0,1-.288.49c-5.716,7.507-12.619,3-12.619,3",
    transform: "translate(-265.194 -56.881)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14217",
    "data-name": "Group 14217",
    transform: "translate(26.404 5.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14216",
    "data-name": "Group 14216",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35244",
    "data-name": "Path 35244",
    d: "M289.309,195.171l8.223.8-9.821,7.237-4.682-3.261v-2.017Z",
    transform: "translate(-283.806 -183.161)",
    fill: "#f14a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_730",
    "data-name": "Line 730",
    x2: 0.476,
    y2: 2.695,
    transform: "translate(1.315 14.503)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_731",
    "data-name": "Line 731",
    x2: 4.872,
    y2: 4.026,
    transform: "translate(3.231 13.076)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_732",
    "data-name": "Line 732",
    x2: 7.964,
    y2: 0.887,
    transform: "translate(5.098 11.911)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14219",
    "data-name": "Group 14219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14218",
    "data-name": "Group 14218",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35246",
    "data-name": "Path 35246",
    d: "M16.253,106.737,9.808,104.92s.959-6.661-6.783-8.135l.624,3-.327.081L2.21,94.833a9.438,9.438,0,0,0,.7,12.809,2.351,2.351,0,0,0,.434.369c7.851,5.237,12.91-1.274,12.91-1.274",
    transform: "translate(0 -86.246)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14221",
    "data-name": "Group 14221",
    transform: "translate(0 8.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14220",
    "data-name": "Group 14220",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35247",
    "data-name": "Path 35247",
    d: "M32.845,206.234l-7.511,3.434,11.644,3.639,3.359-4.605-.658-1.907Z",
    transform: "translate(-23.04 -196.147)",
    fill: "#f14a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_733",
    "data-name": "Line 733",
    x2: 0.428,
    y2: 2.705,
    transform: "translate(14.577 11.08)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_734",
    "data-name": "Line 734",
    x1: 3.294,
    y2: 5.395,
    transform: "translate(9.007 10.354)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_735",
    "data-name": "Line 735",
    x1: 7.239,
    y2: 3.434,
    transform: "translate(2.914 9.863)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14223",
    "data-name": "Group 14223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14222",
    "data-name": "Group 14222",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35249",
    "data-name": "Path 35249",
    d: "M183.207,218.137a7.939,7.939,0,0,1-1.353-.188,6.763,6.763,0,0,0-3.089,0c-.838.359-.423-1.516-.531-1.97s-.729-5.292-.7-6.247-.022-1.636,1.028-5.182c0,0,3.089,2.322,4.635,2.322s4.637-2.322,4.637-2.322c1.051,3.547.991,4.227,1.028,5.182s-.588,5.792-.7,6.247.308,2.329-.531,1.97a6.781,6.781,0,0,0-3.089,0,7.588,7.588,0,0,1-1.345.188",
    transform: "translate(-161.461 -186.028)",
    fill: "#d0e5e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35250",
    "data-name": "Path 35250",
    d: "M283.87,213.65l.318-1.919.185-1.113.18-.155-.082-.414-3.86,2.284-.016,1.056Z",
    transform: "translate(-255.187 -191.029)",
    fill: "#d0e5e1",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14225",
    "data-name": "Group 14225",
    transform: "translate(25.411 19.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14224",
    "data-name": "Group 14224",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35251",
    "data-name": "Path 35251",
    d: "M322.714,211.731l-.55-1.758.121-.645Z",
    transform: "translate(-318.402 -209.397)",
    fill: "#011b2a",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14227",
    "data-name": "Group 14227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14226",
    "data-name": "Group 14226",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35253",
    "data-name": "Path 35253",
    d: "M146.19,219.621l-.627,1.838-.365,1.066-.2.123.012.424,4.182-1.619.188-1.038Z",
    transform: "translate(-131.866 -199.734)",
    fill: "#d0e5e1",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14229",
    "data-name": "Group 14229",
    transform: "translate(13.13 19.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14228",
    "data-name": "Group 14228",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35254",
    "data-name": "Path 35254",
    d: "M144.6,231.471l.253,1.826-.23.615Z",
    transform: "translate(-144.634 -230.399)",
    fill: "#011b2a",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14231",
    "data-name": "Group 14231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14230",
    "data-name": "Group 14230",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35256",
    "data-name": "Path 35256",
    d: "M193.515,207.745c1.981-.185,4.644-3.2,4.644-3.2l.068.231c-2.313,2.441-3.794,3.076-4.725,3.209-.917-.133-2.379-.767-4.665-3.206l.068-.231s2.64,3.021,4.6,3.2Z",
    transform: "translate(-171.737 -186.027)",
    fill: "#088e80",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15473",
    "data-name": "Rectangle 15473",
    width: 0.161,
    height: 0.621,
    transform: "translate(21.697 21.71)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35257",
    "data-name": "Path 35257",
    d: "M214.685,244.146a.037.037,0,0,0-.035-.038h-5.61a.058.058,0,0,0-.03.011.046.046,0,0,0-.008.027v2.161a.037.037,0,0,0,.035.038h5.607a.057.057,0,0,0,.03-.011.046.046,0,0,0,.008-.027Z",
    transform: "translate(-190.076 -222.004)",
    fill: "#088e80",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35258",
    "data-name": "Path 35258",
    d: "M216.778,246.729a.03.03,0,0,0-.011-.027.035.035,0,0,0-.027-.011H211.6a.03.03,0,0,0-.027.011.035.035,0,0,0-.011.027v1.688a.03.03,0,0,0,.011.027.034.034,0,0,0,.027.011h5.144a.03.03,0,0,0,.027-.011.035.035,0,0,0,.011-.027Z",
    transform: "translate(-192.4 -224.352)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35259",
    "data-name": "Path 35259",
    d: "M216.5,253.112l.084.022a.283.283,0,0,1-.1.163.277.277,0,0,1-.172.057.28.28,0,0,1-.169-.044.263.263,0,0,1-.1-.125.447.447,0,0,1-.035-.177.375.375,0,0,1,.038-.18.282.282,0,0,1,.109-.117.317.317,0,0,1,.158-.041.247.247,0,0,1,.253.191l-.084.019a.2.2,0,0,0-.065-.1.164.164,0,0,0-.106-.033.209.209,0,0,0-.125.035.2.2,0,0,0-.071.1.391.391,0,0,0-.022.125.451.451,0,0,0,.025.147.19.19,0,0,0,.073.093.174.174,0,0,0,.109.03.188.188,0,0,0,.121-.044.158.158,0,0,0,.075-.117",
    transform: "translate(-196.449 -229.791)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35260",
    "data-name": "Path 35260",
    d: "M223.463,253.48v-.656h.084v.58h.318v.076Z",
    transform: "translate(-203.228 -229.931)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35261",
    "data-name": "Path 35261",
    d: "M228.272,253.481l.248-.656h.093l.264.656h-.1l-.076-.2h-.269l-.071.2Zm.185-.269h.218l-.068-.181c-.022-.054-.035-.1-.046-.136a.653.653,0,0,1-.035.125Z",
    transform: "translate(-207.602 -229.931)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35262",
    "data-name": "Path 35262",
    d: "M234.819,253.48l-.171-.656h.087l.1.43c.011.046.019.091.027.136.016-.071.027-.112.03-.121l.121-.444h.1l.093.333a1.692,1.692,0,0,1,.049.234c.008-.041.019-.091.033-.144l.1-.422h.087l-.177.656h-.082l-.136-.5c-.011-.044-.019-.068-.019-.076l-.019.076-.136.5Z",
    transform: "translate(-213.4 -229.93)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35263",
    "data-name": "Path 35263",
    d: "M244.386,253.162l.079-.008a.171.171,0,0,0,.027.082.136.136,0,0,0,.065.052.251.251,0,0,0,.1.019.286.286,0,0,0,.084-.014.139.139,0,0,0,.057-.041.1.1,0,0,0,.019-.057.1.1,0,0,0-.016-.054.109.109,0,0,0-.06-.038.9.9,0,0,0-.114-.033.516.516,0,0,1-.125-.041.158.158,0,0,1-.091-.144.184.184,0,0,1,.027-.093.176.176,0,0,1,.082-.065.3.3,0,0,1,.117-.022.344.344,0,0,1,.128.024.188.188,0,0,1,.084.068.232.232,0,0,1,.033.1l-.082.006a.13.13,0,0,0-.044-.1.168.168,0,0,0-.112-.033.177.177,0,0,0-.112.03.091.091,0,0,0-.035.071.075.075,0,0,0,.025.057.328.328,0,0,0,.128.046.877.877,0,0,1,.144.044.181.181,0,0,1,.082.068.16.16,0,0,1,.027.093.174.174,0,0,1-.03.1.178.178,0,0,1-.084.071.246.246,0,0,1-.125.025.389.389,0,0,1-.147-.025.2.2,0,0,1-.093-.079.192.192,0,0,1-.036-.115",
    transform: "translate(-222.256 -229.822)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35264",
    "data-name": "Path 35264",
    d: "M251.023,253.051a.363.363,0,0,1,.087-.256.288.288,0,0,1,.223-.093.3.3,0,0,1,.161.043.266.266,0,0,1,.109.123.419.419,0,0,1,0,.357.264.264,0,0,1-.112.121.307.307,0,0,1-.155.041.291.291,0,0,1-.163-.046.3.3,0,0,1-.109-.121.41.41,0,0,1-.038-.169m.091,0a.276.276,0,0,0,.063.188.215.215,0,0,0,.3.009h0s.008-.005.011-.011a.287.287,0,0,0,.063-.2.364.364,0,0,0-.027-.142.2.2,0,0,0-.079-.093.214.214,0,0,0-.114-.033.22.22,0,0,0-.155.063A.3.3,0,0,0,251.114,253.051Z",
    transform: "translate(-228.292 -229.82)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35265",
    "data-name": "Path 35265",
    d: "M259.054,253.48v-.656h.087l.336.517v-.517h.082v.656h-.087l-.338-.517v.517Z",
    transform: "translate(-235.596 -229.931)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35266",
    "data-name": "Path 35266",
    d: "M231.725,170.735a1.187,1.187,0,0,1-1.108,1.108,1.173,1.173,0,0,1-1.094-1.021.07.07,0,0,1,.055-.083h.069a1.085,1.085,0,0,0,.972.934,1.07,1.07,0,0,0,.961-.885.064.064,0,0,1,.063-.046.684.684,0,0,1,.084-.005",
    transform: "translate(-208.738 -155.275)",
    fill: "#023",
    fillRule: "evenodd"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27481",
    "data-name": "Group 27481",
    transform: "translate(327.394 68.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46961",
    "data-name": "Path 46961",
    d: "M2233.366,185.025l-1.065,1.037-1.858-1.53-1.745,1.323-1.577-.918-.465.8,2.11,1.228,1.654-1.254,1.932,1.592,1.6-1.56Z",
    transform: "translate(-2096.918 -166.121)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46992",
    "data-name": "Path 46992",
    d: "M2233.366,185.025l-1.065,1.037-1.858-1.53-1.745,1.323-1.577-.918-.465.8,2.11,1.228,1.654-1.254,1.932,1.592,1.6-1.56Z",
    transform: "translate(-2104.227 -153.172)",
    fill: "#06233d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClawsonConfetti);
export default __webpack_public_path__ + "static/media/clawson-confetti.bec3e6b10a0255dbe6dab56a24538287.svg";
export { ForwardRef as ReactComponent };